// source: mediainfo.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.himpb.ConfigInfoAgora', null, global);
goog.exportSymbol('proto.himpb.ConfigInfoHisRtc', null, global);
goog.exportSymbol('proto.himpb.ConfigInfoLeiaRtc', null, global);
goog.exportSymbol('proto.himpb.MediaEngineConfigInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.ConfigInfoAgora = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.ConfigInfoAgora, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.ConfigInfoAgora.displayName = 'proto.himpb.ConfigInfoAgora';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.ConfigInfoHisRtc = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.ConfigInfoHisRtc.repeatedFields_, null);
};
goog.inherits(proto.himpb.ConfigInfoHisRtc, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.ConfigInfoHisRtc.displayName = 'proto.himpb.ConfigInfoHisRtc';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.ConfigInfoLeiaRtc = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.ConfigInfoLeiaRtc.repeatedFields_, null);
};
goog.inherits(proto.himpb.ConfigInfoLeiaRtc, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.ConfigInfoLeiaRtc.displayName = 'proto.himpb.ConfigInfoLeiaRtc';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MediaEngineConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.MediaEngineConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MediaEngineConfigInfo.displayName = 'proto.himpb.MediaEngineConfigInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.ConfigInfoAgora.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.ConfigInfoAgora.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.ConfigInfoAgora} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ConfigInfoAgora.toObject = function(includeInstance, msg) {
  var f, obj = {
    appkey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    address: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mode: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.ConfigInfoAgora}
 */
proto.himpb.ConfigInfoAgora.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.ConfigInfoAgora;
  return proto.himpb.ConfigInfoAgora.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.ConfigInfoAgora} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.ConfigInfoAgora}
 */
proto.himpb.ConfigInfoAgora.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppkey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.ConfigInfoAgora.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.ConfigInfoAgora.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.ConfigInfoAgora} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ConfigInfoAgora.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppkey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string appKey = 1;
 * @return {string}
 */
proto.himpb.ConfigInfoAgora.prototype.getAppkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfigInfoAgora} returns this
 */
proto.himpb.ConfigInfoAgora.prototype.setAppkey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address = 2;
 * @return {string}
 */
proto.himpb.ConfigInfoAgora.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfigInfoAgora} returns this
 */
proto.himpb.ConfigInfoAgora.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mode = 3;
 * @return {string}
 */
proto.himpb.ConfigInfoAgora.prototype.getMode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfigInfoAgora} returns this
 */
proto.himpb.ConfigInfoAgora.prototype.setMode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.ConfigInfoHisRtc.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.ConfigInfoHisRtc.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.ConfigInfoHisRtc.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.ConfigInfoHisRtc} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ConfigInfoHisRtc.toObject = function(includeInstance, msg) {
  var f, obj = {
    appkey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    appsecret: jspb.Message.getFieldWithDefault(msg, 2, ""),
    serveraddressList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.ConfigInfoHisRtc}
 */
proto.himpb.ConfigInfoHisRtc.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.ConfigInfoHisRtc;
  return proto.himpb.ConfigInfoHisRtc.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.ConfigInfoHisRtc} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.ConfigInfoHisRtc}
 */
proto.himpb.ConfigInfoHisRtc.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppkey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppsecret(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addServeraddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.ConfigInfoHisRtc.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.ConfigInfoHisRtc.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.ConfigInfoHisRtc} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ConfigInfoHisRtc.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppkey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAppsecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getServeraddressList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string appKey = 1;
 * @return {string}
 */
proto.himpb.ConfigInfoHisRtc.prototype.getAppkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfigInfoHisRtc} returns this
 */
proto.himpb.ConfigInfoHisRtc.prototype.setAppkey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string appSecret = 2;
 * @return {string}
 */
proto.himpb.ConfigInfoHisRtc.prototype.getAppsecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfigInfoHisRtc} returns this
 */
proto.himpb.ConfigInfoHisRtc.prototype.setAppsecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string serverAddress = 3;
 * @return {!Array<string>}
 */
proto.himpb.ConfigInfoHisRtc.prototype.getServeraddressList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.ConfigInfoHisRtc} returns this
 */
proto.himpb.ConfigInfoHisRtc.prototype.setServeraddressList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.ConfigInfoHisRtc} returns this
 */
proto.himpb.ConfigInfoHisRtc.prototype.addServeraddress = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.ConfigInfoHisRtc} returns this
 */
proto.himpb.ConfigInfoHisRtc.prototype.clearServeraddressList = function() {
  return this.setServeraddressList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.ConfigInfoLeiaRtc.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.ConfigInfoLeiaRtc.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.ConfigInfoLeiaRtc.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.ConfigInfoLeiaRtc} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ConfigInfoLeiaRtc.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    appkey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    serveraddressList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.ConfigInfoLeiaRtc}
 */
proto.himpb.ConfigInfoLeiaRtc.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.ConfigInfoLeiaRtc;
  return proto.himpb.ConfigInfoLeiaRtc.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.ConfigInfoLeiaRtc} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.ConfigInfoLeiaRtc}
 */
proto.himpb.ConfigInfoLeiaRtc.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppkey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addServeraddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.ConfigInfoLeiaRtc.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.ConfigInfoLeiaRtc.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.ConfigInfoLeiaRtc} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ConfigInfoLeiaRtc.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAppkey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getServeraddressList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string appId = 1;
 * @return {string}
 */
proto.himpb.ConfigInfoLeiaRtc.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfigInfoLeiaRtc} returns this
 */
proto.himpb.ConfigInfoLeiaRtc.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string appKey = 2;
 * @return {string}
 */
proto.himpb.ConfigInfoLeiaRtc.prototype.getAppkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.ConfigInfoLeiaRtc} returns this
 */
proto.himpb.ConfigInfoLeiaRtc.prototype.setAppkey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string serverAddress = 3;
 * @return {!Array<string>}
 */
proto.himpb.ConfigInfoLeiaRtc.prototype.getServeraddressList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.ConfigInfoLeiaRtc} returns this
 */
proto.himpb.ConfigInfoLeiaRtc.prototype.setServeraddressList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.ConfigInfoLeiaRtc} returns this
 */
proto.himpb.ConfigInfoLeiaRtc.prototype.addServeraddress = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.ConfigInfoLeiaRtc} returns this
 */
proto.himpb.ConfigInfoLeiaRtc.prototype.clearServeraddressList = function() {
  return this.setServeraddressList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MediaEngineConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MediaEngineConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MediaEngineConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MediaEngineConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    mediatype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    agora: (f = msg.getAgora()) && proto.himpb.ConfigInfoAgora.toObject(includeInstance, f),
    hisrtc: (f = msg.getHisrtc()) && proto.himpb.ConfigInfoHisRtc.toObject(includeInstance, f),
    leiartc: (f = msg.getLeiartc()) && proto.himpb.ConfigInfoLeiaRtc.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MediaEngineConfigInfo}
 */
proto.himpb.MediaEngineConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MediaEngineConfigInfo;
  return proto.himpb.MediaEngineConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MediaEngineConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MediaEngineConfigInfo}
 */
proto.himpb.MediaEngineConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMediatype(value);
      break;
    case 2:
      var value = new proto.himpb.ConfigInfoAgora;
      reader.readMessage(value,proto.himpb.ConfigInfoAgora.deserializeBinaryFromReader);
      msg.setAgora(value);
      break;
    case 3:
      var value = new proto.himpb.ConfigInfoHisRtc;
      reader.readMessage(value,proto.himpb.ConfigInfoHisRtc.deserializeBinaryFromReader);
      msg.setHisrtc(value);
      break;
    case 4:
      var value = new proto.himpb.ConfigInfoLeiaRtc;
      reader.readMessage(value,proto.himpb.ConfigInfoLeiaRtc.deserializeBinaryFromReader);
      msg.setLeiartc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MediaEngineConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MediaEngineConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MediaEngineConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MediaEngineConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMediatype();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAgora();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.himpb.ConfigInfoAgora.serializeBinaryToWriter
    );
  }
  f = message.getHisrtc();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.himpb.ConfigInfoHisRtc.serializeBinaryToWriter
    );
  }
  f = message.getLeiartc();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.himpb.ConfigInfoLeiaRtc.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 mediaType = 1;
 * @return {number}
 */
proto.himpb.MediaEngineConfigInfo.prototype.getMediatype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MediaEngineConfigInfo} returns this
 */
proto.himpb.MediaEngineConfigInfo.prototype.setMediatype = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ConfigInfoAgora agora = 2;
 * @return {?proto.himpb.ConfigInfoAgora}
 */
proto.himpb.MediaEngineConfigInfo.prototype.getAgora = function() {
  return /** @type{?proto.himpb.ConfigInfoAgora} */ (
    jspb.Message.getWrapperField(this, proto.himpb.ConfigInfoAgora, 2));
};


/**
 * @param {?proto.himpb.ConfigInfoAgora|undefined} value
 * @return {!proto.himpb.MediaEngineConfigInfo} returns this
*/
proto.himpb.MediaEngineConfigInfo.prototype.setAgora = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.MediaEngineConfigInfo} returns this
 */
proto.himpb.MediaEngineConfigInfo.prototype.clearAgora = function() {
  return this.setAgora(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.MediaEngineConfigInfo.prototype.hasAgora = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ConfigInfoHisRtc hisrtc = 3;
 * @return {?proto.himpb.ConfigInfoHisRtc}
 */
proto.himpb.MediaEngineConfigInfo.prototype.getHisrtc = function() {
  return /** @type{?proto.himpb.ConfigInfoHisRtc} */ (
    jspb.Message.getWrapperField(this, proto.himpb.ConfigInfoHisRtc, 3));
};


/**
 * @param {?proto.himpb.ConfigInfoHisRtc|undefined} value
 * @return {!proto.himpb.MediaEngineConfigInfo} returns this
*/
proto.himpb.MediaEngineConfigInfo.prototype.setHisrtc = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.MediaEngineConfigInfo} returns this
 */
proto.himpb.MediaEngineConfigInfo.prototype.clearHisrtc = function() {
  return this.setHisrtc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.MediaEngineConfigInfo.prototype.hasHisrtc = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ConfigInfoLeiaRtc leiartc = 4;
 * @return {?proto.himpb.ConfigInfoLeiaRtc}
 */
proto.himpb.MediaEngineConfigInfo.prototype.getLeiartc = function() {
  return /** @type{?proto.himpb.ConfigInfoLeiaRtc} */ (
    jspb.Message.getWrapperField(this, proto.himpb.ConfigInfoLeiaRtc, 4));
};


/**
 * @param {?proto.himpb.ConfigInfoLeiaRtc|undefined} value
 * @return {!proto.himpb.MediaEngineConfigInfo} returns this
*/
proto.himpb.MediaEngineConfigInfo.prototype.setLeiartc = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.MediaEngineConfigInfo} returns this
 */
proto.himpb.MediaEngineConfigInfo.prototype.clearLeiartc = function() {
  return this.setLeiartc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.MediaEngineConfigInfo.prototype.hasLeiartc = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.himpb);
